import { Pipe, PipeTransform } from "@angular/core";
import { TerritoryRouteTypeColorsEnum, TerritoryRouteTypeEnum } from "../utilities/enums/TerritoriesEnum";
import { TerritoriesLayerControlService } from "../services/TerritoriesLayerControl.service";

@Pipe({
    name: 'territoryAssignedColor'
})
export class TerritoryAssignedColorPipe implements PipeTransform {
    constructor(private territoriesLayerService: TerritoriesLayerControlService) {}
    transform(territoryId: string) {
        const color = this.territoriesLayerService.assignColor(territoryId);
        return color ? color : null;
    }
}